module.exports = __webpack_public_path__ + "static/img/284_TO8_2431.60e46aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/284_TO8_2431.jpg
// module id = fLJU
// module chunks = 0